import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";

const PatreonInfo = ({imagesrc}) => {

  return (
    <Wrapper>
        <div className='patreon-block-author'>
          <div className="image-container">
            <img src={imagesrc} alt='The chief patron of AMRS' className='patreon-image' />
          </div>   
          <div className='patreon-author-name'>Prof. Benjamin Agyei-Tuffour</div>
          <div className='patreon-author-title'>Chief Patron @AMRS GHANA</div>   
        </div>
        <div className="message-container">
          <p>
            <RiDoubleQuotesL className='patreon-block-quote-open'/>
            Dear Esteemed Readers,
            It is with immense pleasure and a sense of profound honor that I extend my warmest greetings
            to each one of you as the Chief Patron of the African Materials Research Society (AMRS)
            University of Ghana students’ chapter. I am filled with enthusiasm and optimism for the remarkable
            journey that lies ahead.
          </p>
          <p>
            AMRS has always been a vibrant hub of intellect, creativity, camaraderie and hardwork.
            It is a place where like-minded students come together to explore their passions,
            cultivate new skills, and forge lifelong ...
            <RiDoubleQuotesR className='patreon-block-quote-close'/>
          </p>
          <button className='readmore-btn'><Link to='/leadership/chief-patreon'>Read More...</Link></button> 
        </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: whitesmoke;
  .patreon-block-author{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 5em;
    .image-container{
    width: 130px;
    height: 130px;
    img{
      box-shadow: 0 0 1em rgba(0,0,0,0.2);
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    }
    .patreon-author-name{
      font-size: 1.7rem;
      font-weight: bold;
      margin-bottom: .5em;
      margin-top: 1em;
      text-align: center;
    }
    .patreon-author-title{
      font-size: 1.3rem;
    }
  }
  .message-container{
    width: 90%;
    margin-bottom: 5em;
    p{
      font-size: 1.5rem;
      font-weight: 400;
      color: var(--color-black);
      margin: 1em 0;
      line-height: 1.5;
      svg{
        color: var(--primary-color);
        font-size: 1.3rem;
      }
      .patreon-block-quote-open{
        vertical-align: super;
        margin-right: .3em; 
      }
      .patreon-block-quote-close{
        vertical-align: bottom;
        margin-left: .3em;
      }
    }
    .readmore-btn{
      padding: 0;
      border: none;
      background-color: transparent;
        a{  
            font-size: 1.3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--primary-color);
        }
    }
  }

  /* Media Queries */
  @media only screen and (min-width: 800px){
    flex-direction: unset;
    .patreon-block-author{
      margin-top: unset;
      .patreon-author-name{
        font-size: 1.5rem;
      }
    }
    .message-container{
      text-align: justify;
      margin:8em 3em;
      width: 50%;
      p{
        text-align: unset;
        svg{
          font-size: 1.7rem;
        }
      }
    }
  }
`;

export default PatreonInfo